export const environment = {
  production: true,
  appointmentsApiURL: window.location.origin + '/appointments',
  appointmentsPublicUrl: 'https://termine.famabc.de',
  patientAppBaseUrl: 'https://termine.famabc.de/patient'
};
